<template>
  <div class="product-content">
    <h2 class="product-name">{{ briefInfo.name }}</h2>
    <div class="product-meta">
      <div class="meta-item"  :class="{'meta-item_en':currentLanguage !== 'zh'}">
        <div class="meta-item-box">
          <span class="label">{{ $t('products.panel.EnglishName') }}：</span>
          <span class="value">{{ briefInfo.nameOther || '-' }}</span>
        </div>
      </div>
      <div class="meta-item"  :class="{'meta-item_en':currentLanguage !== 'zh'}">
        <div class="meta-item-box">
          <span class="label">{{ $t('products.panel.ArtNo') }}：</span>
          <span class="value">{{ briefInfo.sn || '-' }}</span>
        </div>
      </div>
      <div class="meta-item"  :class="{'meta-item_en':currentLanguage !== 'zh'}">
        <div class="meta-item-box">
          <span class="label">{{ $t('products.panel.UsagePlatform') }}：</span>
          <span class="value">{{ briefInfo.platform || '-' }}</span>
        </div>
      </div>
      <div class="meta-item"  :class="{'meta-item_en':currentLanguage !== 'zh'}">
        <div class="meta-item-box">
          <span class="label">{{ $t('products.panel.ec') }}：</span>
          <span class="value">{{ briefInfo.ecNo || '-' }}</span>
        </div>
      </div>
      <div class="meta-item"  :class="{'meta-item_en':currentLanguage !== 'zh'}">
        <div class="meta-item-box">
          <span class="label"> {{ $t('products.panel.CAS') }}：</span>
          <span class="value">{{ briefInfo.casNo || '-'}}</span>
        </div>
      </div>
    </div>
    <div class="action-buttons">
      <el-button type="primary" class="inquiry-btn" @click.stop="productInquiry">
        <i class="el-icon-message"></i>
        {{ $t('products.detail.batchInquiry') }}
      </el-button>
      <el-button type="primary" class="purchase-btn" @click.stop="purchase">
        <i class="el-icon-shopping-cart-2"></i>
        {{ $t('products.detail.researchPurchase') }}
      </el-button>
      <el-button type="primary" class="sample-btn" @click.stop="productModel">
        <i class="el-icon-box"></i>
        {{ $t('products.detail.getSample') }}
      </el-button>
    </div>

  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: 'biology',
  props: {
    briefInfo: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapState({
      currentLanguage: state => state.app.language
    })
  },
  methods: {
    productInquiry() {
      this.$emit('productInquiry')
    },
    purchase() {
      this.$emit('purchase')
    },
    productModel() {
      this.$emit('productModel')
    },

    handleScroll() {
      const sections = this.navItems.map(item => this.$refs['format' + item.id])
      const scrollPosition = window.scrollY + 100

      // 检查产品信息区域的按钮是否在视窗内
      const productContent = document.querySelector('.product-content')
      if (productContent) {
        const actionButtons = productContent.querySelector('.action-buttons')
        if (actionButtons) {
          const rect = actionButtons.getBoundingClientRect()
          this.showBottomActions = rect.bottom < 0
        }
      }

      // 只有在有导航项时才进行滚动检测
      if (this.navItems.length) {
        sections.forEach((section, index) => {
          if (section && section[0]) {
            const navHeight = document.querySelector('.detail-nav')?.offsetHeight || 0
            const sectionTop = section[0].offsetTop - navHeight
            const sectionBottom = sectionTop + section[0].offsetHeight

            if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
              this.activeSection = this.navItems[index].id
            }
          }
        })
      }
    },
  }
}
</script>

<style lang="less" scoped>
.product-content {
  width: 100%;
  .product-name {
    font-size: 36px;
    font-weight: 600;
    color: #ffffff;
    margin: 0 0 30px;
    padding-bottom: 15px;
    border-bottom: none;
    text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  }

  .product-meta {
    margin-bottom: 40px;
    padding: 40px;
    background-color: rgba(255, 255, 255, 0.2);
    border: 1px solid #979797;

    .meta-item {
      margin-bottom: 12px;
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 8px 0;
      & .meta-item-box {
        flex: 1;
        display: flex;
        align-items: center;
      }
      &:last-child {
        border-bottom: none;
        margin-bottom: 0;
      }

      .label {
        width: 120px;
        color: #ffffff;
        font-size: 16px;

      }

      .value {
        flex: 1;
        color: #ffffff;
        font-size: 16px;
      }
    }
    .meta-item_en {
      display: block !important;
      .label {
        width: auto !important;
        display: block !important;
      }

      .value {
        display: block !important;
      }
    }
  }

  .action-buttons {
    display: flex;
    padding: 0;
    gap: 15px;
    margin-top: 30px;

    .el-button {
      flex: 1;
      padding: 0 20px;
      height: 50px;
      border-radius: 4px;
      font-size: 16px;


      i {
        margin-right: 8px;
        font-size: 18px;
      }

      &:hover {
        opacity: 0.9;
        transform: translateY(-2px);
        transition: all 0.3s;
      }
    }

    .inquiry-btn {
      background: #FFFFFF;
      box-shadow: 0 2px 4px 0 rgba(0,0,0,0.5);
      border-color: #323C46;
      color: #000;
    }

    .purchase-btn {
      background: #FFFFFF;
      box-shadow: 0 2px 4px 0 rgba(0,0,0,0.5);
      border-color: #323C46;
      color: #000;
    }

    .sample-btn {
      background: #FFFFFF;
      box-shadow: 0 2px 4px 0 rgba(0,0,0,0.5);
      border-color: #323C46;
      color: #000;
    }
  }
}
</style>